<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="我的代表队" name="team">
      <team></team>
    </el-tab-pane>
    <el-tab-pane label="选手管理" name="player">
      <team-player></team-player>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import TeamPlayer from '../components/TeamPlayer'
import Team from '../components/TeamManagement'
export default {
  components: {
    TeamPlayer, Team
  },
  data () {
    return {
      activeName: 'player'
    };
  },
  methods: {}
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/teamplayerlist.vue